import fetch from 'isomorphic-fetch';
import moment from 'moment';
import Cookies from 'universal-cookie';
import { setCookie, setLocalStorage } from '../util/storage';
import * as ActionType from './types/WeddingActionTypes';
import * as NotificationActions from './NotificationActions';

function requestWedding() {
  return {
    type: ActionType.REQUEST_WEDDING
  };
}

export function receiveWeddingAccount(json) {
  return {
    type: ActionType.RECEIVE_WEDDING_ACCOUNT,
    payload: {
      account: json
    }
  };
}

function receiveWedding(json) {
  return {
    type: ActionType.RECEIVE_WEDDING,
    payload: {
      wedding: json
    }
  };
}

function requestTheme() {
  return {
    type: ActionType.THEME_REQUESTED
  };
}

function receiveTheme(json) {
  return {
    type: ActionType.THEME_RECEIVED,
    payload: {
      theme: json
    }
  };
}

function requestThemeGroup() {
  return {
    type: ActionType.THEMEGROUP_REQUESTED
  };
}

function receiveThemeGroup(json) {
  return {
    type: ActionType.THEMEGROUP_RECEIVED,
    payload: {
      theme: json
    }
  };
}

export function selectTheme(themeId) {
  return {
    type: ActionType.THEME_SELECT,
    payload: {
      id: themeId
    }
  };
}

// This may not be needed but i need to get something to prod
export function disableWebsiteOnboarding() {
  return {
    type: ActionType.DISABLE_WEBSITE_ONBOARDING
  };
}

export function enableGuestListOnboarding() {
  return {
    type: ActionType.ENABLE_GUEST_LIST_ONBOARDING
  };
}

export function fetchWedding() {
  return (dispatch) => {
    dispatch(requestWedding());
    return fetch('/web-api/v1/wedding',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWedding(json)));
  };
}

export function fetchWeddingAccount() {
  return (dispatch) => {
    dispatch(requestWedding());
    return fetch('/web-api/v1/weddingAccount',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWeddingAccount(json)))
      .catch(err => console.log('fetchweddingaccount err:', err));
  };
}

export function createWedding(createWeddingRequest) {
  const cookies = new Cookies();
  cookies.set('allGuestsBanner', true, { path: '/' });
  cookies.set('trackRsvpBanner', true, { path: '/' });
  cookies.set('websiteRsvpBanner', true, { path: '/' });
  return (dispatch, getState) => {
    // Format Date
    const finalRequest = {
      ...createWeddingRequest,
      event_date: moment.utc(createWeddingRequest.wedding_date),
      wedding_date: moment.utc(createWeddingRequest.wedding_date).format('YYYY-MM-DD')
    };
    const createRoute = '/web-api/v1/wedding/onboard-submit';
    let { primaryProduct } = getState().Onboard;
    const { businessUnitComponent } = getState().Onboard;
    const { userContext } = getState().user;
    return fetch(createRoute,
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(finalRequest)
      })
      .then(response => response.json())
      .then((json) => {
        dispatch(receiveWedding(json));
        const isExistingUser = userContext.has_registry || userContext.has_wedding_account || userContext.has_invitation_account || userContext.is_inspiration_vendor || !!userContext.has_inspiration_account;
        if (businessUnitComponent !== '') {
          primaryProduct = businessUnitComponent;
        }
        if (primaryProduct === 'REGISTRY') {
          setLocalStorage('trackRegistryCreate', 'true');
          setLocalStorage('trackRegistryCreateIsExistingUser', isExistingUser.toString());
          // set a flag for checklist to know that the user just signed up
          setCookie('checklistOnboard', true, 1);
        }
      });
  };
}

export function createWeddingForRegistryAccountUser() {
  return dispatch => (
    fetch('/web-api/v1/weddingAccount/create/account',
      {
        credentials: 'same-origin',
        method: 'POST'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWedding(json)))
      // .then(() => dispatch(weddingAccountCreated(true)))
  );
}

// make sure the respoonse is handled by receiveWeddingAccount, not receiveWedding
// otherwise calling this can overwrite the wedding data in the redux store
export function createWeddingForExistingUser() {
  return dispatch => (
    fetch('/web-api/v1/weddingAccount/create/account',
      {
        credentials: 'same-origin',
        method: 'POST'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWeddingAccount(json)))
  );
}

export function fetchWeddingThemeGroup(key) {
  return (dispatch) => {
    dispatch(requestThemeGroup());
    return fetch(`/web-api/v2/theme/${key}`,
      {
        credentials: 'same-origin',
      })
      .then(response => response.json())
      .then(json => dispatch(receiveThemeGroup(json)));
  };
}

export function fetchWeddingTheme() {
  return (dispatch) => {
    dispatch(requestTheme());
    return fetch('/web-api/v1/wedding/theme',
      {
        credentials: 'same-origin',
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTheme(json)))
      .then(json => dispatch(fetchWeddingThemeGroup(json.payload.theme.key)));
  };
}

export function fetchWeddingThemeV2(themeKey) {
  return (dispatch) => {
    dispatch(requestTheme());
    return fetch(`/web-api/v2/theme/${themeKey}`,
      {
        credentials: 'same-origin',
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTheme(json)));
  };
}

export function updateWeddingTheme(themeId) {
  return (dispatch, getState) => (
    fetch('/web-api/v1/wedding/theme',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          theme_id: themeId
        })
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTheme(json)))
      .then(() => dispatch(fetchWeddingThemeGroup(getState().wedding.theme.key)))
      .then(() => dispatch(NotificationActions.confirmation({ message: `${getState().wedding.themeGroupTitle} Design Selected` })))
  );
}

export function updateWebsitePublish(enable) {
  return dispatch => (
    fetch('/web-api/v1/weddingAccount/publish',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ enable })
      })
      .then(() => dispatch(fetchWeddingAccount()))
      .then(() => {
        if (enable) {
          // Send publish website optimizely event for current running test
          window.optimizely = window.optimizely || [];
          window.optimizely.push({
            type: 'event',
            eventName: 'Website Published'
          });
        }
      })
  );
}

export const toggleWebsite = value => (dispatch) => {
  dispatch({ type: ActionType.TOGGLE_WEBSITE });
  return dispatch(updateWebsitePublish(value));
};

export function updateWeddingAccount(request) {
  return dispatch => (
    fetch('/web-api/v1/weddingAccount/update',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(request)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWeddingAccount(json)))
  );
}

export function updateSearchSettings(request) {
  return dispatch => (
    fetch('/web-api/v1/wedding/searchSettings',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'PUT',
        body: JSON.stringify(request)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWedding(json)))
  );
}
export function updateWedding(request) {
  return dispatch => (
    fetch('/web-api/v1/wedding/update',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(request)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveWedding(json)))
  );
}

export function updateShowPoiMap(hidden) {
  return (dispatch, getState) => {
    const weddingAccount = getState().wedding.account;
    weddingAccount.enable_poi_maps = hidden;
    dispatch(updateWeddingAccount(weddingAccount));
  };
}

export function updateGuestListOnboarding(enable) {
  return dispatch => (
    fetch('/web-api/v1/weddingAccount/guest_list_onboarding',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ enable })
      })
      .then(() => dispatch(fetchWeddingAccount()))
  );
}



// WEBPACK FOOTER //
// ./src/actions/WeddingActions.js